import { render, staticRenderFns } from "./FashionManager.vue?vue&type=template&id=27f72aba&scoped=true&"
import script from "./FashionManager.vue?vue&type=script&lang=js&"
export * from "./FashionManager.vue?vue&type=script&lang=js&"
import style0 from "./FashionManager.vue?vue&type=style&index=0&id=27f72aba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f72aba",
  null
  
)

export default component.exports